import React from 'react'
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import Fab from '@material-ui/core/Fab';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputBase from '@material-ui/core/InputBase';
import { withStyles } from '@material-ui/styles';
import authStore from "../../authStore";
import { observer } from 'mobx-react'
import CurrentUserProfilePic from '../CurrentUserProfilePic';
import { reports } from '../../firestorter'
import FeedItem from '../FeedItem'
import { Redirect } from "react-router-dom";

const classes = {
    panel: {
        backgroundColor: '#b14d9b',
        color: 'white',
        textAlign: 'center',
        padding: '1rem'
    },
    reportButton: {
        width: '30%'
    },
    search: {
        width: '100%',
        '&:before': {
            border: 'none'
        },
        '&.Mui-focused': {
            '&:before': {
                border: 'none'
            },
        }
    },
    searchFab: {
        backgroundColor: 'white',
        marginBottom: '20px',
        width: '80%',
        padding: 0,
    }
};

const Profile = observer(class Profile extends React.Component {
    constructor() {
        super()
        this.state = {
            email: '',
            displayName: '',
            user: authStore.user.get()
        }
    }
    componentDidMount() {
        const headerElem = document.getElementById('header');
        if (headerElem) {
            this.setState({ height: window.innerHeight - headerElem.offsetHeight })
        }

        this.setState({
            email: this.state.user.email,
            displayName: this.state.user.displayName
        })
    }
    onDisplayNameChanged(event) {
        const updateParams = { displayName: event.target.value }
        this.setState(updateParams)
        // Update remote

        authStore.updateUser(updateParams)
    }
    onEmailChanged(event) {
        const updateParams = { email: event.target.value }
        this.setState(updateParams)
        // Update remote

        authStore.updateUser(updateParams)
    }
    componentWillUnmount(){
        reports.query = null
    }
    render() {
        const { classes } = this.props;
        const profilePic = authStore.loggedIn ?
            <CurrentUserProfilePic height="9.5rem" _style={{ fontSize: '8rem' }} /> :
            <AccountCircleIcon style={{ fontSize: '5.5rem', marginBottom: '1rem' }} />

        let userReports = []
        let hasReports = false
        
        if (this.state.user) {
            reports.query = reports.ref.where('user_id', '==', this.state.user.uid);
            userReports = reports.docs.map((r,i) => {
                return r.data.deleted ? null : <FeedItem report={r} currentUser={this.state.user} key={i}/>
            })
            hasReports = !!userReports.length
        }

        return (
            <div className={classes.panel} style={{ height: `${this.state.height}px`, flex: 1, overflow: 'auto' }}>
                {this.state.user ? <div>
                    {profilePic}
                
                    <div style={{ marginTop: '1rem' }}>
                        <Fab className={classes.searchFab} variant="extended" aria-label="name">
                            <InputBase
                                style={{ fontSize: '1.4rem' }}
                                placeholder="השם שלי"
                                className={classes.search}
                                value={this.state.displayName}
                                onChange={this.onDisplayNameChanged.bind(this)}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <AccountCircleIcon htmlColor="#b14d9b" style={{ fontSize: '3rem' }} />
                                    </InputAdornment>
                                }
                            />
                        </Fab>

                        <Fab className={classes.searchFab} variant="extended" aria-label="mail">
                            <InputBase
                                style={{ fontSize: '1.4rem' }}
                                placeholder="mail@mailbox.com"
                                className={classes.search}
                                onChange={this.onEmailChanged.bind(this)}
                                value={this.state.email}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <MailIcon htmlColor="#b14d9b" style={{ fontSize: '3rem' }} />
                                    </InputAdornment>
                                }
                            />
                        </Fab>
                    </div>
                    <div style={{ margin: 'auto', width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                        {this.state.user.score ? <div>
                            <div style={{ fontSize: '4rem', fontWeight: 'bold' }}>{this.state.user.score}</div>
                            <div style={{ fontSize: '1rem' }}>נקודות סה"כ</div>
                        </div> : null}

                        {/* <div>
                            <div style={{ fontSize: '40px', fontWeight: 'bold' }}>15</div>
                            <div style={{ fontSize: '1rem' }}>מתוך 5,345</div>
                        </div> */}
                    </div>

                    <div style={{ marginTop: '2rem', borderTop: '0.1rem solid rgba(255,255,255,0.1)' }}>
                        {hasReports ? <div>{ userReports }</div> : <div style={{ marginTop: '2rem' }}>אין דיווחים</div>}

                    </div>
                </div> : <Redirect to='/' />}

            </div>
        )
    }
})

export default withStyles(classes)(Profile);